import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Downloads from '../components/Downloads';
import CodePlayground from '../components/CodePlayground';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <Hero />
        <Features />
        <CodePlayground />
        <Downloads />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
};

export default Home;